import React, { useEffect } from 'react';
import './App.css';
import { ThemeProvider } from '@mui/material';
import Navbar from './customer/components/Navbar/Navbar';
import Footer from './customer/pages/Home/Footer';
import customeTheme from './Theme/customeTheme';
import Home from './customer/pages/Home/Home';
import Product from './customer/pages/Product/Product';
import ProductDetails from './customer/pages/Page Details/ProductDetails';
import Cart from './customer/pages/Cart/Cart';
import Checkout from './customer/pages/Checkout/Checkout';
import Account from './customer/pages/Account/Account';
import { Route, Routes, useLocation } from 'react-router-dom';
import BecomeSeller from './customer/pages/Become Seller/BecomeSeller';
import SellerDashboard from './seller/pages/SellerDashbord/sellerDashboard';

// Ensure the folder casing matches your file structure on disk:
import AdminDashboard from './admin/components/AdminDashboard';

import { useAppDispatch, useAppSelector } from './State/Store';
import { fetchSellerProfile } from './State/seller/SellerSlice';
import Auth from './customer/pages/Auth/Auth';
import { fetchUserProfile } from './State/AuthSlice';
import Wishlist from './customer/Wishlist/Wishlist';
import { createHomeCategories } from './State/customer/customerSlice';
import { homeCategories } from './data/HomeCategories';
import AdminLoginForm from './admin/Pages/Auth/AdminLoginForm';
import CustomerLayout from "./customer/pages/Home/CustomerLayout";
import SellerProducts from './customer/pages/Seller/SellerProducts';

// Helper component to track single-page route changes with Meta Pixel
const PixelTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      (window as any).fbq('track', 'PageView');
    }
  }, [location]);

  return null;
};

function App() {
  const dispatch = useAppDispatch();
  const location = useLocation();

  const { auth } = useAppSelector(store => store);
  const user = auth.user;
  const jwt = auth.jwt || localStorage.getItem("jwt");

//  useEffect(() => {
//    const formattedCategories = homeCategories.map((category, index) => ({
//      ...category,
//      id: index + 1,
//    }));
//    dispatch(createHomeCategories(formattedCategories));
//  }, [dispatch]);

  useEffect(() => {
    if (jwt) {
      dispatch(fetchUserProfile({ jwt }));
    }
  }, [jwt, dispatch]);

  useEffect(() => {
    const userRole = user?.role as string;
    if (jwt && user && (userRole === "ROLE_SELLER" || userRole === "Role_Seller")) {
      dispatch(fetchSellerProfile(jwt));
    }
  }, [jwt, user, dispatch]);

  // Exclude /seller-store from being considered a dashboard view
  const isDashboardView =
    (location.pathname.startsWith("/seller") && !location.pathname.startsWith("/seller-store")) ||
    location.pathname.startsWith("/admin");

  return (
    <ThemeProvider theme={customeTheme}>
      <PixelTracker />
      <div className="flex flex-col min-h-screen">
        {/* Navbar renders on all non-dashboard pages including /seller-store */}
        {!isDashboardView && <Navbar />}

        <main className="flex-grow">
          <Routes>
            {/* Customer Home Route only inside CustomerLayout */}
            <Route element={<CustomerLayout />}>
              <Route path="/" element={<Home />} />
            </Route>

            {/* Standard Customer Routes (Loaded under Navbar and Footer) */}
            <Route path="/seller-store/:sellerId" element={<SellerProducts />} />
            <Route path="/products" element={<Product />} />
            <Route path="/products/:category" element={<Product />} />
            <Route path="/product-details/:categoryId/:name/:productId" element={<ProductDetails />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/account/*" element={<Account />} />
            <Route path="/vendor" element={<BecomeSeller />} />

            {/* Standalone Dashboard & Auth Pages */}
            <Route path="/login" element={<Auth />} />
            <Route path="/admin/login" element={<AdminLoginForm />} />
            <Route path="/seller/*" element={<SellerDashboard />} />
            <Route path="/admin/*" element={<AdminDashboard />} />
          </Routes>
        </main>

        {/* Footer renders on all non-dashboard pages including /seller-store */}
        {!isDashboardView && <Footer />}
      </div>
    </ThemeProvider>
  );
}

export default App;